import * as React from "react";
import { IconProps } from "./types";

export default function Data({ svgProps, pathProps }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_1149_472)">
        <path
          d="M3 21V19L5 17V21H3ZM7 21V15L9 13V21H7ZM11 21V13L13 15.03V21.01H11V21ZM15 21V15.02L17 13.02V21H15ZM19 21V11L21 9V21H19ZM3 15.83V13L10 6L14 10L21 3V5.83L14 12.83L10 8.83L3 15.83Z"
          fill="currentColor"
          {...pathProps}
        />
      </g>
      <defs>
        <clipPath id="clip0_1149_472">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
